import React from 'react'

export const NoBroadCastIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.70337 7.28503H11.9923V14.0406H2.70337V7.28503Z"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9922 11.9295L14.7997 12.9822C14.8635 13.0061 14.9321 13.0142 14.9996 13.0058C15.0672 12.9975 15.1318 12.9729 15.1878 12.9342C15.2438 12.8955 15.2896 12.8438 15.3213 12.7835C15.3531 12.7233 15.3698 12.6562 15.37 12.5881V8.7386C15.3698 8.67051 15.3531 8.60348 15.3213 8.54323C15.2896 8.48298 15.2438 8.43129 15.1878 8.39258C15.1318 8.35387 15.0672 8.32929 14.9996 8.32092C14.9321 8.31255 14.8635 8.32065 14.7997 8.34453L11.9922 9.39615V11.9295Z"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.39233 10.8739C4.39233 11.1539 4.50354 11.4223 4.7015 11.6203C4.89945 11.8183 5.16794 11.9295 5.44789 11.9295C5.72784 11.9295 5.99633 11.8183 6.19428 11.6203C6.39224 11.4223 6.50345 11.1539 6.50345 10.8739C6.50345 10.594 6.39224 10.3255 6.19428 10.1275C5.99633 9.92957 5.72784 9.81836 5.44789 9.81836C5.16794 9.81836 4.89945 9.92957 4.7015 10.1275C4.50354 10.3255 4.39233 10.594 4.39233 10.8739V10.8739Z"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.19214 10.8739C8.19214 11.1539 8.30335 11.4223 8.5013 11.6203C8.69926 11.8183 8.96774 11.9295 9.24769 11.9295C9.52764 11.9295 9.79613 11.8183 9.99408 11.6203C10.192 11.4223 10.3032 11.1539 10.3032 10.8739C10.3032 10.594 10.192 10.3255 9.99408 10.1275C9.79613 9.92957 9.52764 9.81836 9.24769 9.81836C8.96774 9.81836 8.69926 9.92957 8.5013 10.1275C8.30335 10.3255 8.19214 10.594 8.19214 10.8739V10.8739Z"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.44775 9.81836H9.24775"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5255 3.90726H11.5699C11.4579 3.90726 11.3506 3.95174 11.2714 4.03092C11.1922 4.11011 11.1477 4.2175 11.1477 4.32948V5.17392C11.1477 5.2859 11.1922 5.3933 11.2714 5.47248C11.3506 5.55166 11.4579 5.59615 11.5699 5.59615H14.5255C14.7494 5.59615 14.9642 5.50718 15.1226 5.34881C15.281 5.19045 15.3699 4.97566 15.3699 4.7517C15.3699 4.52774 15.281 4.31295 15.1226 4.15459C14.9642 3.99623 14.7494 3.90726 14.5255 3.90726Z"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1479 4.75171H10.3034C10.0795 4.75171 9.86468 4.84068 9.70632 4.99904C9.54795 5.1574 9.45898 5.37219 9.45898 5.59615V7.28504"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.12549 5.59616H6.50327C6.72723 5.59616 6.94201 5.68513 7.10038 5.84349C7.25874 6.00186 7.34771 6.21664 7.34771 6.44061V7.28505"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="0.646447"
      y1="16.2085"
      x2="15.7314"
      y2="1.12361"
      stroke="#6B6B6B"
    />
  </svg>
)
